import * as React from 'react';
import { SVGProps } from 'react';

const IconWatchFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12Zm-11-.041V4h-2v11l6.553 4.589L20.7 17.95 15 13.96Z"
    />
  </svg>
);
export default IconWatchFilledSizeL;
